import { Component, EventEmitter, input, Input, Output, signal } from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatIconModule} from '@angular/material/icon';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'app-organizations-item',
    imports: [MatExpansionModule, MatIconModule, CommonModule],
    templateUrl: './organizations-item.component.html',
    styleUrl: './organizations-item.component.scss'
})
export class OrganizationItemComponent {
  title = input.required<string>()
  openDescription = input.required<string>()
  closedDescription = input.required<string>()
  @Input() organizations: any[] = [];
  @Output() selectBallot = new EventEmitter<number>()
  isOpen = signal(false);

  constructor( private announcer: LiveAnnouncer,) { }

  onOpen() {
    this.isOpen.set(true) 
    this.announcer.announce(` ${this.organizations.length} ${this.title} available in list.`, 'assertive');
  }

  onClose() {
    this.isOpen.set(false) 
  }

}
